import { useEffect, useRef, useState } from 'react';
import "./GenericSelect.css";

export type GenericSelectOption = {
    displayName: string;
    value: any;
    image?: string;
    component?: JSX.Element;
}

type GenericSelectProps = {
    selected?: GenericSelectOption;
    options: GenericSelectOption[];
    onChange: (value: any) => void;
    maxHeight?: string;
}

export const GenericSelect = ({ selected, options, onChange, maxHeight, ...rest }: GenericSelectProps) => {

	const [isOpen, setIsOpen] = useState(false);

    const selectRef = useRef(null);

    useEffect(() => {
        document.addEventListener('keydown', eventKeyDown);
        document.addEventListener('mousedown', eventMouseDown);

        // get rid of the clickout event handler if needed
        return () => {
            document.removeEventListener('keydown', eventKeyDown, true);
            document.removeEventListener('mousedown', eventMouseDown);
        }
    }, []);

    const eventMouseDown = (e: any) => {
        const current = selectRef.current as any;

        if (current && !current.contains(e.target)) {
            setIsOpen(false);
        }
    }

    const eventKeyDown = (e: any) => {
        if (e.key === 'Escape') {
            e.stopPropagation();
            setIsOpen(false);
        }
    }

    const handleClick = (e: any) => {
        // if it is now going to be open
        if (!isOpen) {
            document.addEventListener('keydown', eventKeyDown, true);
        }

        setIsOpen(!isOpen);
    }

    

    return (
		<div className="generic-select-container">
            <div 
                className="generic-select"
                onClick={handleClick}
                style={{
                    ...(isOpen ? {zIndex: 101} :{}),
                    ...(maxHeight ? {maxHeight: maxHeight} : {})
                    }}
                ref={selectRef}
            >
                <div 
                    className="generic-select-selected"
                >
					{selected && selected.image && 
                        <img src={selected.image} />
                    }
                    {selected && selected.component &&
                        selected.component
                    }
					{selected && selected.displayName}
                </div>

                {isOpen &&
                    <div className="generic-select-options">
                        {options.map((option: GenericSelectOption) => {
                            return (				
                                <div 
                                    key={option.value}
                                    className="generic-select-option"
                                    onClick={() => {
                                        onChange(option.value);
                                        setIsOpen(false);
                                    }}
                                >
                                    {option.component &&
                                        option.component
                                    }
									{option.image && 
                                        <img src={option.image} />
                                    }
									{option.displayName}
                                </div>
                            )
                        }
                        )}
                    </div>
                }

            </div>
        </div>
    )
}
